import { SendEmailButton, ViewButton } from "@/components/IconButton/variants";
import ReopenButton from "@/components/IconButton/variants/ReopenButton";
import {
  CONTACT_SUPPORT_STATUS,
  CONTACT_SUPPORT_TYPE,
} from "@/constant/ContactSupport/status";
import PropTypes from "prop-types";
import React from "react";
import { useNavigate } from "react-router-dom";

function Actions({
  row,
  handleMarkUnread = false,
  handleReopenTicket = false,
}) {
  const navigate = useNavigate();

  return (
    <div className="w-auto flex gap-x-1 justify-center">
      <ViewButton
        onClick={() =>
          navigate(
            `/communication-management/support-tickets/${row.original.id}/goto`
          )
        }
        tooltipText="Go To"
      />
      {handleMarkUnread && (
        <SendEmailButton
          onClick={() => handleMarkUnread(row.original)}
          tooltipText={
            row.original.status.name === CONTACT_SUPPORT_STATUS.UNREAD ||
            row.original.status.type === CONTACT_SUPPORT_TYPE.CLOSED
              ? ""
              : "Mark Unread"
          }
          buttonStyle={{
            visibility:
              row.original.status.name === CONTACT_SUPPORT_STATUS.UNREAD ||
              row.original.status.type === CONTACT_SUPPORT_TYPE.CLOSED
                ? "hidden"
                : "visible",
          }}
        />
      )}
      {handleReopenTicket && (
        <ReopenButton
          onClick={() => handleReopenTicket(row.original)}
          tooltipText={
            row.original.status.type === CONTACT_SUPPORT_TYPE.CLOSED
              ? "Reopen Ticket"
              : ""
          }
          buttonStyle={{
            visibility:
              row.original.status.type !== CONTACT_SUPPORT_TYPE.CLOSED
                ? "hidden"
                : "visible",
          }}
        />
      )}
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  handleMarkUnread: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  handleReopenTicket: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

export default React.memo(Actions);
